'use strict';

var React = require('react');
var styled = require('styled-components');
var Text = require('@swiggy-private/dls-web-core/dist/components/Text');
var SpriteIconWeb = require('@swiggy-private/dls-web-food-icons/dist/SpriteIconWeb');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const Container = styled__default.default.div(({ theme }) => ({
    display: "flex",
    marginTop: theme.spacing.small,
}));
const RatingText = styled__default.default(Text.Text)(({ textColor, theme }) => ({
    marginLeft: theme.spacing.xxxSmall,
    color: textColor,
}));
const CountText = styled__default.default(Text.Text)(({ theme }) => ({
    marginLeft: theme.spacing.xxxSmall,
}));
const IconContainer = styled__default.default.div(() => ({
    width: "14px",
    height: "14px",
}));

const RATING_TOKENS = {
    RATING_4: "#116649",
    RATING_3_4: "#1BA672",
    RATING_0_3: "#E6A408",
};

const Ratings = ({ rating, ratingCount }) => {
    const fillColor = React.useMemo(() => {
        const ratingValue = parseFloat(rating);
        if (ratingValue >= 4) {
            return RATING_TOKENS.RATING_4;
        }
        else if (ratingValue >= 3) {
            return RATING_TOKENS.RATING_3_4;
        }
        else {
            return RATING_TOKENS.RATING_0_3;
        }
    }, [rating]);
    return (React__default.default.createElement(Container, null,
        React__default.default.createElement(IconContainer, null,
            React__default.default.createElement(SpriteIconWeb.SpriteIconWeb, { iconName: "starfilled16", fillColor: "positive", strokeColor: "positive" })),
        React__default.default.createElement(RatingText, { variant: "V2.body3.neutral.bold", textColor: fillColor }, rating),
        React__default.default.createElement(CountText, { color: "text_Med_Emphasis", variant: "V2.body3.neutral.medium" }, `(${ratingCount})`)));
};
var Ratings$1 = React.memo(Ratings);

exports.Ratings = Ratings$1;
//# sourceMappingURL=Rating-Dy9qwprD.js.map
